(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reducedMotion ? 'auto' : 'smooth';

  document.querySelectorAll('.article-product-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.article-product-carousel__track');
    var prevBtn = carousel.querySelector('.carousel-btn--prev');
    var nextBtn = carousel.querySelector('.carousel-btn--next');

    if (!track || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = track.querySelector('.article-product-carousel__card');
      if (!card) return 300;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    function updateButtons() {
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: behavior });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: behavior });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });

    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollBy({ left: -getScrollAmount(), behavior: behavior });
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        track.scrollBy({ left: getScrollAmount(), behavior: behavior });
      }
    });

    updateButtons();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateButtons, 150);
    }, { passive: true });
  });
})();